module.exports = __webpack_public_path__ + "img/tether-1.93b229fe.svg";